import api from '@/services/apiService';

// Dashboard Stats
export interface DashboardStats {
  total_fields_booked: number;
  total_communities: number;
  total_events_joined: number;
  total_events_hosted: number;
}

// Upcoming Booking
export interface UpcomingBooking {
  invoice_number: string;
  arena_name: string;
  arena_image: string;
  booking_date: string;
  start_time: string;
  end_time: string;
  payment_status: string;
  booking_status: string;
  total_price: number;
  field_count: number;
}

// Pagination
export interface Pagination {
  current_page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

// Upcoming Bookings Response
export interface UpcomingBookingsResponse {
  bookings: UpcomingBooking[];
  pagination: Pagination;
}

// Upcoming Event
export interface UpcomingEvent {
  event_name: string;
  event_slug: string;
  date: string;
  location: string;
  role: string;
  status: string;
  start_time: string;
  end_time: string;
  sport_category?: string;
  sport_category_slug?: string;
}

// Dashboard Data
export interface DashboardData {
  stats: DashboardStats;
  upcoming_bookings: UpcomingBookingsResponse;
  upcoming_events: UpcomingEvent[];
}

// API Response
export interface DashboardResponse {
  success: boolean;
  message: string;
  data: DashboardData;
}

// Unpaid Mabar Event Transaction
export interface UnpaidEventTransaction {
  id: number;
  order_number: string;
  event_title: string;
  event_slug: string;
  event_date: string;
  lokasi_arena: string;
  amount: number;
  status: string;
  xendit_invoice_url?: string;
}

// Get client dashboard data
const getClientDashboard = async (): Promise<DashboardResponse> => {
  const response = await api.get('/client/dashboard');
  return response.data;
};

// Get unpaid mabar events for current client member
const getUnpaidEvents = async (): Promise<{ success: boolean; data: UnpaidEventTransaction[] }> => {
  try {
    const response = await api.get('/client/unpaid-events');
    return response.data;
  } catch (err) {
    console.error('Failed to get unpaid events:', err);
    return { success: false, data: [] };
  }
};

export const clientDashboardService = {
  getClientDashboard,
  getUnpaidEvents,
};
